<template>
  <div class="content-contrainer">
    <html404 v-if="!content||!content.content" tit="敬请期待"></html404>
    <div v-else style="padding-top: 120px;" v-html="content.content"></div>
    <div class="main-box" v-if="content.videos&&content.videos.length">
      <h2 class="text-center content-block-title" style="font-size: 38px;font-weight: 400; height: 100px; line-height: 100px;">视频回顾</h2>
      <el-row :gutter="20">
        <el-col :span="18">
          <video :poster="video.thumb" style="background-color: #000;" width="882px" height="595px" :src="video.link" controls="controls">
          您的浏览器不支持 video 标签。
          </video>
          <p style="margin:0; line-height: 40px; font-size: 18px; color: #162ea8;">{{video.title}}</p>
        </el-col>
        <el-col :span="6">
          <div class="video-list">
            <div :class="'video-list-item '+(index==activeVidexId?'active':'')" :key="index" v-for="(item, index) in content.videos">
              <a @click="checkVideo(index)" href="javascript:;">
              <div class="play-icon">
                <i class="el-icon-video-play"></i>
              </div>
              <img :src="item.thumb" :title="item.title" :alt="item.title" />
              </a>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { navbar, news as data } from "../../data.js";
import html404 from "../../components/404.vue";
import lang from "../../lang.js";
import { setTimeout } from 'timers';
export default {
  name: "newscontent",
  components:{
    html404
  },
  data() {
    return {
      lang,
      data,
      active:0,
      activeVidexId: "",
      video: {
        title: "",
        link: ""
      }
    };
  },
  computed:{
    menus(){
      return navbar({
        lang:this.$route.params.lang || 'zh-CN'
      })
    },
    childrenMenu(){
      return this.menus.find(v=>v.id=="news");
    },
    __lang(){return this.$route.params.lang},
    content(){
      const lang = this.__lang;
      const id = this.$route.params.id;
      const type = this.$route.params.type;
      let __data = this.data[lang][type].list.find(v=>v.id==id);
      if (!__data) {
        __data = {};
      }
      return __data;
    },
    routeName(){
      return this.$route.name;
    }
  },
  methods:{
    checkLabor(index) {
      this.active = index;
    },
    checkVideo(index) {
      this.activeVidexId = index;
      this.video = this.content.videos.find((v,i)=>i===index);
    }
  },
  mounted(){
    setTimeout(()=>{
      if (this.content&&this.content.videos){
        this.checkVideo(0);
      }
    },200);
    console.log(this.$route.name, this.content);
  }
};
</script>

<style lang="less" scoped>
.content-block-title {
  background: url(../../assets/img/shangfeng.png) center no-repeat;
  color: darkblue;
}
.video-list{
  height: 595px;
  overflow: auto;
  width: 100%;
}
.video-list-item {
  box-sizing: border-box;
  border: 6px solid #fff;
  overflow: hidden;
  width:260px;
  height: 183px;
  background-color: blue;
  margin-bottom: 10px;
  position: relative;
  &.active {
    border: 6px solid #f5bf81;
  }
  a{
    display: block;
    width: 100%;
    height: 100%;
  }
  .play-icon {
    position: absolute;
    width:50px;
    height: 50px;
    line-height: 50px;
    top: 50%;
    margin-top: -25px;
    left: 50%;
    margin-left: -25px;
    font-size: 48px;
    color: #fff;
  }
}
.content-contrainer {
  padding-bottom: 60px;
}
.content-banner {
  margin-top: 70px;
  width: 100%;
  height: 340px;
  background: url(../../assets/img/banner_news.jpg) center center no-repeat;
  &.en {
    background: url(../../assets/img/banner_news_en.png) center center no-repeat;
  }
}
.content-menu-list {
  border-bottom: 1px solid #999;
  overflow: hidden;
  .content-menu-list-item {
    text-decoration: none;
    color: #222;
    float: left;
    line-height: 60px;
    font-size: 16px;
    padding: 0 20px;
    &.active{
      color: #d22c1d;
    }
    &.active:after {
      display: block;
      content: " ";
      width: 60%;
      height: 4px;
      background-color: #d22c1d;
      margin: auto;
    }
  }
}
.filed-desc {
  padding: 40px 0;
  line-height: 30px;
  font-size: 18px;
}
.labor-checkbox {
  margin-bottom: 40px;
  .labor-checkbox-btn {
    display:block;
    width: 100%;
    text-align: center;
    line-height: 60px;
    height: 60px;
    padding: 0;
    background-color: #eee;
    color: #222;
    text-decoration: none;
    border-radius: 0;
    font-size: 18px;
    .icon {
      width: 36px;
      display: inline-block;
      height: 100%;
      vertical-align:
      middle;margin-right: 10px;
    }
    .icon1 {
      display: none;
    }
    .icon2{
      display: inline-block;
    }
    &.active{
      color: #fff;
      background-color: #d22c1d;
      .icon2 {
        display: none;
      }
      .icon1{
        display: inline-block;
      }
    }
  }
}
.st-desc {
  position: relative;
  .text1-box {
    position: absolute;
    top: 0;
    left: 130px;
    right: 143px;
    margin: 100px auto;
    height: 130px;
    .icon{
      margin-top: 20px;
      margin-left: 100px;
      margin-right: 50px;
      float: left;
    }
    p{
      color: #fff;
      margin-top: 20px;
      margin-right: 50px;
      line-height: 1.8;
    }
  }
}
.databox {
  margin-top: 20px;
}
.datacontent {
  img{
    width: 100%;
  }
}
</style>
